<div class="outline light-primary-border-color">
  <div class="header">Log In</div>

  <form (ngSubmit)="onSubmit()" [formGroup]="loginForm">
    <div class="form-group">
      <label for="email">Email</label>
      <input
        type="text"
        class="form-control"
        id="login-email"
        name="email"
        formControlName="email"
      />
    </div>

    <div class="form-group">
      <label for="password">Password</label>
      <input
        type="password"
        class="form-control"
        id="login-password"
        formControlName="password"
      />
    </div>

    <div class="form-group">
      <div class="row">
        <div class="col-md-6">
          <a [routerLink]="['/login', 'reset']">Forgot your password?</a>
        </div>

        <div class="col-md-6 remember">
          <input type="checkbox">&nbsp;&nbsp;Remember Me
        </div>
      </div>
    </div>

    <div class="form-group">
      <button
        [disabled]="loginForm.invalid"
        class="pv-button"
        [ngClass]="{ disabled: loginForm.invalid }"
      >
        Log In
      </button>
    </div>
    <div>{{ message }}</div>
  </form>
</div>